import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-float";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(transformNeighborhoodsToCities),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(writeHashDataToFilterSet),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(writeFiltersFromData),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(writeFiltersFromQuerystring);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { put, call, select, all } from 'redux-saga/effects';
import { filterSetFilters } from 'redux/saga/selectors';
import { querySelector } from 'redux/saga/selectors/request';
import { deepExtract } from 'helpers/deep';
import { getFilterableTagIds } from 'helpers/filters';
import { isEmpty } from 'helpers/verify';
import { AMENITY, LEVEL, LOCATION } from 'constants/filterset-ids';
export var extractHash = function extractHash(hashDescriptor) {
  return hashDescriptor ? hashDescriptor.match(/[^-]*/)[0] : '';
};
export var convertFilterDataToHashQuery = function convertFilterDataToHashQuery(filterSetId) {
  return function (state, msaId) {
    var defaultFilters = {
      entity_type: 'fitness-studio',
      extended: true,
      meta: true,
      msa_id: [String(msaId)]
    };
    var filters = deepExtract("filterSets.".concat(filterSetId, ".filters"), state, {});
    var locationIds = Object.keys(deepExtract('location.itemIdSelected', filters, {}));
    var locationFilters = isEmpty(locationIds) ? {} : {
      location: locationIds
    }; // If the the activity filter does not have a filterable property
    // that means the tags service was not used to dynamically populate any filters
    // and therefore use the 'legacy' logic to manually add activities to the tagFilters
    // Eventually tags will populate all filters and this logic can be removed

    var tagIds;

    if (filters.activity && typeof filters.activity.filterable === 'undefined') {
      tagIds = Object.keys(filters.activity.itemIdSelected).map(String);
    } else {
      tagIds = getFilterableTagIds(filters).reduce(function (memo, filterId) {
        var itemIdSelected = deepExtract('itemIdSelected', filters[filterId], {});
        return [].concat(_toConsumableArray(memo), _toConsumableArray(Object.keys(itemIdSelected).map(String)));
      }, []);
    }

    var tagFilters = tagIds.length > 0 ? {
      tag: tagIds
    } : {};
    var amenityFilters = Object.keys(filters.amenity ? filters.amenity.itemIdSelected : {}).reduce(function (memo, amenity) {
      return _objectSpread({}, memo, _defineProperty({}, amenity, ['true']));
    }, {});
    var levelFilters = Object.keys(filters.level ? filters.level.itemIdSelected : {}).reduce(function (memo, level) {
      return _objectSpread({}, memo, _defineProperty({}, level, ['true']));
    }, {});

    var allFilters = _objectSpread({}, defaultFilters, locationFilters, tagFilters, amenityFilters, levelFilters);

    return allFilters;
  };
};
export var getLocationParentChildCounts = function getLocationParentChildCounts(state, filterSet) {
  var parentedItemIds = deepExtract("filterSets.".concat(filterSet, ".filters.location.parentedItemIds"), state, {});
  return Object.keys(parentedItemIds).reduce(function (memo, parentId) {
    return _objectSpread({}, memo, _defineProperty({}, parentId, parentedItemIds[parentId].length));
  }, {});
}; // Due to Search API limitations, we transform any L2 locations to the corresponding L3s,
// so we need to transform any full set of L3s back to its corresponding L2 on the way back.

export function transformNeighborhoodsToCities(filterSet) {
  var location,
      _ref,
      _ref2,
      locationParentChildCounts,
      itemsById,
      locationQueryChildCounts,
      _args = arguments;

  return regeneratorRuntime.wrap(function transformNeighborhoodsToCities$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          location = _args.length > 1 && _args[1] !== undefined ? _args[1] : [];
          _context.next = 3;
          return all([select(getLocationParentChildCounts, filterSet), select(deepExtract.bind(null, "filterSets.".concat(filterSet, ".filters.location.itemsById")))]);

        case 3:
          _ref = _context.sent;
          _ref2 = _slicedToArray(_ref, 2);
          locationParentChildCounts = _ref2[0];
          itemsById = _ref2[1];

          if (itemsById) {
            _context.next = 9;
            break;
          }

          return _context.abrupt("return", []);

        case 9:
          locationQueryChildCounts = location.reduce(function (memo, itemId) {
            return _objectSpread({}, memo, _defineProperty({}, itemsById[itemId].parent_id, memo[itemsById[itemId].parent_id] + 1 || 1));
          }, {});
          return _context.abrupt("return", Object.keys(location.reduce(function (memo, itemId) {
            return _objectSpread({}, memo, locationQueryChildCounts[itemsById[itemId].parent_id] === locationParentChildCounts[itemsById[itemId].parent_id] ? _defineProperty({}, itemsById[itemId].parent_id, true) : _defineProperty({}, itemId, true));
          }, {})).map(function (itemId) {
            return parseInt(itemId, 10);
          }));

        case 11:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function writeHashDataToFilterSet(filterActions, _ref5) {
  var _objectSpread6;

  var query, filterSet, location, filters, filterIds, tagIds, selectedTagsByFilterId, filterData;
  return regeneratorRuntime.wrap(function writeHashDataToFilterSet$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          query = _ref5.query;
          filterSet = filterActions.filterSet;
          _context2.next = 4;
          return call(transformNeighborhoodsToCities, filterSet, query.location);

        case 4:
          location = _context2.sent;
          _context2.next = 7;
          return select(filterSetFilters, filterSet);

        case 7:
          filters = _context2.sent;
          filterIds = Object.keys(filters);
          tagIds = query.tag || []; // Grab the parent (aka L2 tagIds) filterIds from each selected tagId

          selectedTagsByFilterId = filterIds.reduce(function (tagsByFilterId, filterId) {
            var selectedTagIdsForFilterId = tagIds.filter(function (tagId) {
              return filters[filterId].itemsById[tagId];
            });

            var newTagsByFilterId = !isEmpty(selectedTagIdsForFilterId) && _defineProperty({}, filterId, selectedTagIdsForFilterId);

            return _objectSpread({}, tagsByFilterId, newTagsByFilterId);
          }, []);
          filterData = _objectSpread({}, selectedTagsByFilterId, {
            location: location
          } || {}, (_objectSpread6 = {}, _defineProperty(_objectSpread6, LEVEL, ['level_beginner', 'level_all', 'level_advanced'].filter(function (level) {
            return (query[level] || [])[0] === 'true';
          })), _defineProperty(_objectSpread6, AMENITY, ['shower', 'towel', 'locker', 'mat'].filter(function (amenity) {
            return (query[amenity] || [])[0] === 'true';
          })), _objectSpread6));
          _context2.next = 14;
          return put(filterActions.clearFilterSet());

        case 14:
          _context2.next = 16;
          return Object.keys(filterData).filter(function (filterId) {
            return filterData[filterId] && filterData[filterId].length;
          }).map(function (filterId) {
            return put(filterActions.toggleItemId.apply(filterActions, [filterId].concat(_toConsumableArray(filterData[filterId]))));
          });

        case 16:
          _context2.next = 18;
          return put(filterActions.setClean());

        case 18:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function writeFiltersFromData(filterActions, filterSet, data) {
  var filters;
  return regeneratorRuntime.wrap(function writeFiltersFromData$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(filterActions.clearFilterSet());

        case 2:
          _context3.next = 4;
          return select(filterSetFilters, filterSet);

        case 4:
          filters = _context3.sent;
          _context3.next = 7;
          return all(_toConsumableArray(Object.keys(data).reduce(function (actions, filterId) {
            var filterObj = filters[filterId];

            if (filterId === LOCATION) {
              var _data$filterId$split = data[filterId].split(','),
                  _data$filterId$split2 = _toArray(_data$filterId$split),
                  lat = _data$filterId$split2[0],
                  lon = _data$filterId$split2[1],
                  name = _data$filterId$split2.slice(2);

              actions.push(put(filterActions.setFilterValue(filterId, {
                lat: parseFloat(lat),
                lon: parseFloat(lon),
                name: name.join(',')
              })));
            } else if (filterObj && filterObj.isValueFilter) {
              actions.push(put(filterActions.setFilterValue(filterId, data[filterId])));
            } else if (filterObj) {
              actions.push(put(filterActions.toggleItemId.apply(filterActions, [filterId].concat(_toConsumableArray([].concat(data[filterId]))))));
            }

            return actions;
          }, [])));

        case 7:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function writeFiltersFromQuerystring(filterActions, filterSet) {
  var queryData;
  return regeneratorRuntime.wrap(function writeFiltersFromQuerystring$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return select(querySelector);

        case 2:
          queryData = _context4.sent;
          _context4.next = 5;
          return call(writeFiltersFromData, filterActions, filterSet, queryData);

        case 5:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
export function createQuerystringFromFilters(state, filterSet) {
  var filters = deepExtract("filterSets.".concat(filterSet, ".filters"), state, {});
  return Object.keys(filters).filter(function (filterId) {
    return filters[filterId].filtered;
  }).reduce(function (query, filterId) {
    // Cursors are too long to in the query at this time
    // Upcoming backend work will shorten them
    if (filterId === 'cursor') {
      return query;
    }

    if (filterId === LOCATION) {
      var _filters$filterId$val = filters[filterId].value,
          lat = _filters$filterId$val.lat,
          lon = _filters$filterId$val.lon,
          name = _filters$filterId$val.name;
      query[filterId] = "".concat(lat, ",").concat(lon, ",").concat(name);
    } else if (filters[filterId].isValueFilter) {
      query[filterId] = filters[filterId].value;
    } else {
      query[filterId] = Object.keys(filters[filterId].itemIdSelected);
    }

    return query;
  }, {});
}